import React, { useState } from 'react';
import '../styles/DevelopmentSection.css';

const DevelopmentSection = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <section className="development">
      <div className="development-content">
        <h2>Entwicklung digitaler Anwendungen</h2>
        <p>Unser Schwerpunkt liegt auf der Entwicklung und dem Vertrieb digitaler Lösungen.<br /> Wir setzen auf moderne Technologien und nutzerfreundliche Konzepte.</p>
        <button
          className="projects-button"
          onClick={() => setShowPopup(true)}
        >
          Projekte
        </button>

        {/* Pop-up */}
        {showPopup && (
          <div className="popup-overlay" onClick={() => setShowPopup(false)}>
            <div
              className="popup-content"
              onClick={(e) => e.stopPropagation()} // Verhindert Schließen beim Klick auf den Inhalt
            >
              <span
                className="close-button"
                onClick={() => setShowPopup(false)}
              >
                &times;
              </span>
              <h3>Aktuelle Projekte</h3>
              <p>
                Mit Skilt Studio haben wir eine digitale Lernplattform für das Handwerk geschaffen. Ideen für weitere Projekte sind bereits in den Startlöchern.
              </p>
              <a
                href="https://skilt.app"
                className="popup-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Zu Skilt Studio
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DevelopmentSection;
